import { Card, Stack } from "@mui/material";
import ItemSelect from "../../../item/view/item.select";
import { ItemMov, Movimentacao } from "../../mov.model";
import { ViewCadastroItemMov } from "./itemMovCadView";
import { ItemMovList } from "./itemMovListView";
import { TabelaPrecoItem } from "../../../../data.types";

interface CardSelecionarItemProps {
    mov: Movimentacao;
    addItem: (item: any,tabela:TabelaPrecoItem, isDoubleClick: boolean) => any;
}

export const CardSelecionarItem = (props: CardSelecionarItemProps) => {
    const { mov, addItem } = props;
    console.log("Mov em CardSelecionarItem",mov)
    if (mov.situacao === "INICIADO" || mov.situacao === "ABERTO") {
        return (

            <Stack spacing={1} sx={{ display: "flex", flex: 1, flexDirection: "column", mr: 1 }}>
                <Card sx={{ flex: 1 }}>
                    <ItemSelect
                        handleItemSelect={(i) => addItem(i.item,i.tabela, false)}
                        needTabPreco
                        tabelaPadrao={mov.pessoa.tabela_preco_padrao}
                        //tabela={mov.pessoa.revenda ? "ATACADO" : "VAREJO"}
                        //handleItemDobleClick={(i) => addItem(i, true)}
                    />

                </Card>

            </Stack>
        )
    }
    return null
}


interface CardListItemMovProps {
    mov: Movimentacao;
    mutatorLocal: (value: any, field: string) => any;
    showMovItem: { item: ItemMov; show: boolean; operation: string };
    setShowMovItem: (value: { item: ItemMov; show: boolean; operation: "itemMovAdd"|"itemMovUpd"|"" }) => any;
    showButtonNew: boolean;
    handleButtonNew: () => any;
}



export const CardListItemMov = (props:CardListItemMovProps) => {
    const { mov, mutatorLocal, showMovItem, setShowMovItem,handleButtonNew,showButtonNew } = props
    return (
        <Card sx={{ display: "flex", flex: 4 }} >
            <ViewCadastroItemMov
                itemMov={showMovItem.item}
                confirme={(item) => { mutatorLocal(item, showMovItem.operation); }}
                remove={(item) => mutatorLocal(item, "itemMovRem")}
                handleClose={() => setShowMovItem({ item: {} as ItemMov, show: false, operation: "" })}
                open={showMovItem.show}
            />
            <ItemMovList
                mov={mov}
                handleAlterar={(i) => setShowMovItem({ item: i, show: true, operation: "itemMovUpd" })}
                handleAddItem={() => handleButtonNew()}
                showButtonNew={showButtonNew}
            />
        </Card>
    )
}